import React from 'react';

interface CardButtonProps extends React.HTMLProps<HTMLButtonElement> {
	children: React.ReactNode;
}

export default function CardButton(props: CardButtonProps) {
	return (
		<button className="roc-card-list__button" {...props} type="button">
			{props.children}
		</button>
	);
}

CardButton.defaultProps = {
	disabled: false,
};
